import type { CreditTrackingInterface } from 'srcLegacy/shared/renter-hub/models/Types';

const TOKEN_VALIDITY_MINUTES = 60;

export const isTokenValid = (creditTracking?: { arrayUserToken?: string; lastFetchedTimestamp?: number }): boolean => {
  if (!creditTracking?.arrayUserToken || !creditTracking?.lastFetchedTimestamp) {
    return false;
  }

  const currentTime = Date.now();
  const tokenAge = currentTime - creditTracking.lastFetchedTimestamp;
  return tokenAge < TOKEN_VALIDITY_MINUTES * 60 * 1000;
};

export const getEnrollmentStatus = (creditTracking: CreditTrackingInterface | undefined): string => {
  if (!creditTracking) {
    return 'NOT_ENROLLED';
  }

  if (creditTracking.enrollmentStatus === 'OPTED_OUT') {
    return 'OPTED_OUT';
  }

  if (creditTracking.arrayUserToken && isTokenValid(creditTracking)) {
    return 'ENROLLED';
  }

  return 'NOT_ENROLLED';
};
